export const KNOWN_INSIGHT_TYPES = [
  "shifts-worked",
  "earnings",
  "top-workplaces",
  "patients-helped",
] as const;
export type KnownInsightType = (typeof KNOWN_INSIGHT_TYPES)[number];

export type InsightWrapperVariant = KnownInsightType | "start" | "end" | "loading";
